export interface ClientVersion {
    clientVersionText: string,
}
export interface ApiVersion {
    apiVersionText: string,
}

// returns a default API Version generic text for development and instantiation
export const getApiVersionDefault = (): ApiVersion => ({ apiVersionText: 'API Version' });

// returns the current Client Version for deployed instances and generic text for development
export const getClientVersion = (): ClientVersion => {
  let clientVersionText = '12.0.3';// this value will be updated in the CI process for valid tags.
  if (clientVersionText.toLowerCase() === 'Replace_Version_Text'.toLowerCase()) {
    clientVersionText = 'Client Version';
  }
  const clientVersion = { clientVersionText };// returning an object for future extensibility
  return clientVersion;
};
